module.exports = __webpack_public_path__ + "img/joker.9b77abca.png";